// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-documentation) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.checkbox-column {
  display: inline-block;
  width: 30%;
}

.required-document-label {
  font-size: 12px;
  text-align: left;
  font-weight: 400;
  margin-bottom: 20px;
  color: #4a4a4a;
}

.myapplication-document-label {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
  color: var(--theme-main-color, #055C8D);
}

.row-margins {
  margin-bottom: 5px;
  margin-top: 5px;
}

.justify-content-end {
  margin-right: 1.5%;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.custom-checkbox > [type=checkbox]:disabled + label {
  cursor: not-allowed;
  font-weight: 700;
  color: #000000;
}

.table-height {
  height: 40vh;
}

.view-link {
  vertical-align: middle;
}

.link-text {
  padding: 0 5px 0 2px;
  cursor: pointer;
}

.form-check-label-highlighted {
  background-color: #FF0;
}

.custom-required-document-label {
  color: black !important;
  text-decoration: none !important;
  cursor: pointer;
}

.table-header {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
